"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Remove = void 0;
var cantillation = /[\u{0591}-\u{05AF}\u{05BF}\u{05C0}\u{05C3}-\u{05C6}\u{05F3}\u{05F4}]/gu;
var vowels = /[\u{05B0}-\u{05BD}\u{05BF}\u{05C7}]/gu;
var shinDot = /\u{05C1}/gu;
var sinDot = /\u{05C2}/gu;
var removeItem = function (text, item) { return text.replace(item, ""); };
exports.Remove = function (text, _a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.removeVowels, removeVowels = _c === void 0 ? false : _c, _d = _b.removeShinDot, removeShinDot = _d === void 0 ? false : _d, _e = _b.removeSinDot, removeSinDot = _e === void 0 ? false : _e;
    var remCantillation = removeItem(text, cantillation);
    var remVowels = removeVowels ? removeItem(remCantillation, vowels) : remCantillation;
    var remShin = removeShinDot ? removeItem(remVowels, shinDot) : remVowels;
    var remSin = removeSinDot ? removeItem(remShin, sinDot) : remShin;
    return remSin;
};
//# sourceMappingURL=remove.js.map